// extracted by mini-css-extract-plugin
export var chevron = "_lr-2";
export var chevronRotated = "_lr-3";
export var header = "_lr-1";
export var section = "_lr-0";